/* BR BW - black and white redesign behaviour, 17 Sep 2026.
   1. Product page (snippets/br-pdp.liquid): gallery, options copied onto the real form,
      Add to cart taps the real submit button, description split into accordions.
   2. Product cards: photos swipe inside the card, round + adds to cart
      (a small picker opens first when the piece has sizes or other choices).
   Loaded from layout/theme.liquid. Delete the script tag there to switch it all off;
   the product page then still has the theme's own form, which assets/br-bw.css keeps
   off screen, so also remove the BR PDP block in br-bw.css if reverting. */
(function () {
  'use strict';
  var d = document;

  function money(txt) { return (txt || '').replace(/\s+/g, ' ').replace(/\.00(?!\d)/g, '').trim(); }
  function toast(msg, link) {
    var t = d.getElementById('br-toast');
    if (!t) { t = d.createElement('div'); t.id = 'br-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.innerHTML = '<span></span>' + (link ? '<a href="/cart">View bag</a>' : '');
    t.firstChild.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }
  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      d.querySelectorAll('[data-cart-count], .cart-count, .site-header__cart-count, .cart-link__count').forEach(function (n) { n.textContent = c.item_count; });
      d.dispatchEvent(new CustomEvent('br:cart', { detail: c }));
    }).catch(function () {});
  }
  function addVariant(id, btn) {
    if (btn) { btn.classList.add('is-pressed'); btn.setAttribute('aria-busy', 'true'); }
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { toast('Added to bag', true); refreshCount(); })
      .catch(function (e) { if (btn) btn.classList.remove('is-pressed'); toast((e && e.description) || 'Could not add this piece'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  /* ---------------- 1. PRODUCT PAGE ---------------- */
  function initPdp() {
    var root = d.getElementById('br-pdp');
    if (!root) return;
    d.body.classList.add('br-pdp-on');
    var form = d.querySelector('.adtocartmobile form.product-form') || d.querySelector('form.product-form');
    var real = form && form.querySelector('button[data-cart-submit]');
    var atc = d.getElementById('br-pdp-atc');
    var priceOut = d.getElementById('br-pdp-price');
    var priceNode = d.querySelector('.add-to-cart-placed .product__current-price') || d.querySelector('.product__current-price');
    var variants = [];
    try { variants = JSON.parse(d.getElementById('br-pdp-variants').textContent); } catch (e) {}

    /* header height, so the phone photo fills exactly the rest of the screen */
    function setTop() {
      var h = d.querySelector('.site-header') || d.querySelector('header');
      var top = h ? Math.max(0, h.getBoundingClientRect().bottom + window.pageYOffset) : 120;
      d.documentElement.style.setProperty('--br-hdr', Math.round(top) + 'px');
    }
    setTop(); window.addEventListener('load', setTop); window.addEventListener('resize', setTop);

    /* gallery */
    var track = d.getElementById('br-pdp-track');
    var slides = track ? track.children : [];
    var thumbs = root.querySelectorAll('.br-pdp__thumb');
    var lines = root.querySelectorAll('.br-pdp__lines b');
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      lines.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    function go(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    if (track) {
      var tmr;
      track.addEventListener('scroll', function () {
        clearTimeout(tmr);
        tmr = setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60);
      }, { passive: true });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.getAttribute('data-i'))); }); });

    /* options -> real selects */
    function selects() { return form ? form.querySelectorAll('select[data-option-input]') : []; }
    function currentVariant() {
      var chosen = [];
      selects().forEach(function (s) { chosen.push(s.value); });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < chosen.length; k++) { if (v.options[k] !== chosen[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function sync() {
      if (priceNode && priceOut) { var p = money(priceNode.textContent); if (p) priceOut.textContent = p; }
      var v = currentVariant();
      if (atc) {
        var sold = (real && real.disabled) || (v && !v.available);
        atc.disabled = !!sold;
        atc.textContent = sold ? 'Sold out' : 'Add to cart';
      }
      return v;
    }
    root.querySelectorAll('[data-br-option]').forEach(function (group) {
      var name = group.getAttribute('data-br-option');
      group.querySelectorAll('button[data-value]').forEach(function (b) {
        b.addEventListener('click', function () {
          var val = b.getAttribute('data-value');
          selects().forEach(function (s) {
            if (s.name === name || s.id === name) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
          });
          group.querySelectorAll('button[data-value]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
          if (atc) atc.classList.remove('is-pressed');
          setTimeout(function () {
            var v = sync();
            if (v && v.featured_media && track) {
              for (var i = 0; i < slides.length; i++) { if (String(slides[i].getAttribute('data-media-id')) === String(v.featured_media.id)) { go(i); break; } }
            }
          }, 90);
        });
      });
    });
    if (priceNode && window.MutationObserver) new MutationObserver(sync).observe(priceNode.parentNode || priceNode, { childList: true, subtree: true, characterData: true });
    sync();

    if (atc) atc.addEventListener('click', function () {
      if (atc.disabled) return;
      atc.classList.add('is-pressed');
      if (real) { real.click(); }
      else { var v = currentVariant(); if (v) addVariant(v.id, atc); }
    });

    /* Try & Buy buttons move into the panel */
    var tb = d.querySelector('.adtocartmobile .three_btn_below_addtocart');
    var tbHome = d.getElementById('br-pdp-trybuy');
    if (tb && tbHome && tb.querySelector('a')) { tbHome.appendChild(tb); tbHome.classList.add('is-on'); }

    /* description -> accordions */
    var acc = d.getElementById('br-pdp-acc');
    if (acc) {
      var det = acc.querySelector('[data-k="details"] .br-acc__b');
      var box = { details: [], material: [], dims: [], care: [] };
      var mode = 'details';
      var nodes = Array.prototype.slice.call(det.children);
      nodes.forEach(function (n) {
        var t = (n.textContent || '').replace(/ /g, ' ').trim().toLowerCase();
        if (!t && !n.querySelector('img')) return;
        var head = t.replace(/[*:.\s]+$/, '');
        if (/^specifications?$/.test(head)) { mode = 'material'; n.remove(); return; }
        if (/^(dimensions?|size and fit|fit)$/.test(head)) { mode = 'dims'; n.remove(); return; }
        if (/^(material and fit info|material and fit|material|materials)$/.test(head)) { mode = 'material'; n.remove(); return; }
        if (/^care$/.test(head)) { mode = 'care'; n.remove(); return; }
        var target = mode;
        if (/^(length|width|height|weight|diameter|size|drop|inner diameter)\b[^a-z]{0,4}/.test(t)) target = 'dims';
        else if (/^(base material|material|type|stone|stones|finish|plating)\b\s*:/.test(t)) target = 'material';
        else if (/^care\s*:/.test(t)) target = 'care';
        else if (/^note\s*:/.test(t)) target = box.dims.length ? 'dims' : (box.material.length ? 'material' : 'details');
        box[target].push(n);
      });
      function fill(k) {
        var item = acc.querySelector('[data-k="' + k + '"]');
        if (!item || !box[k].length) return false;
        var b = item.querySelector('.br-acc__b');
        if (k === 'care') b.innerHTML = '';
        box[k].forEach(function (n) { b.appendChild(n); });
        if (k === 'care') { var p = d.createElement('p'); p.innerHTML = '<a href="/pages/jewellery-care">Jewellery care and material</a>'; b.appendChild(p); }
        item.hidden = false;
        return true;
      }
      fill('material'); fill('dims'); fill('care');
      if (!det.children.length) { var dItem = acc.querySelector('[data-k="details"]'); if (dItem) dItem.hidden = true; }
      var first = acc.querySelector('.br-acc__i:not([hidden])');
      acc.querySelectorAll('.br-acc__i').forEach(function (i) { if (i !== first) i.open = false; });
      if (window.matchMedia('(max-width: 767.98px)').matches && first) first.open = false;
    }
  }

  /* ---------------- 2. CARDS ---------------- */
  function initCards(scope) {
    (scope || d).querySelectorAll('.br-media').forEach(function (m) {
      if (m._br) return; m._br = true;
      var sc = m.querySelector('.br-media__scroll');
      var dots = m.querySelectorAll('.br-media__dots b');
      if (sc && dots.length > 1) {
        var h;
        sc.addEventListener('scroll', function () {
          clearTimeout(h);
          h = setTimeout(function () {
            var i = Math.round(sc.scrollLeft / Math.max(1, sc.clientWidth));
            dots.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
          }, 50);
        }, { passive: true });
        m.querySelectorAll('.br-media__arrow').forEach(function (a) {
          a.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var dir = a.classList.contains('br-media__arrow--next') ? 1 : -1;
            sc.scrollBy({ left: dir * sc.clientWidth, behavior: 'smooth' });
          });
        });
      }
    });
  }

  function polishOf(btn) {
    var card = btn.closest('.card, .br-best__card');
    if (!card) return 'silver';
    if (card.hasAttribute('data-polish')) return card.getAttribute('data-polish');
    var cb = card.querySelector('input.varient-col');
    return cb && cb.checked ? 'gold' : 'silver';
  }

  function openPicker(handle, btn, polish) {
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var sheet = d.getElementById('br-pick');
      if (!sheet) {
        sheet = d.createElement('div'); sheet.id = 'br-pick';
        sheet.innerHTML = '<div class="br-pick__bg"></div><div class="br-pick__box" role="dialog" aria-modal="true"><button type="button" class="br-pick__x" aria-label="Close">&times;</button><p class="br-pick__name"></p><p class="br-pick__price"></p><div class="br-pick__opts"></div><button type="button" class="br-pick__add">Add to cart</button></div>';
        d.body.appendChild(sheet);
        sheet.querySelector('.br-pick__bg').addEventListener('click', function () { sheet.classList.remove('is-on'); });
        sheet.querySelector('.br-pick__x').addEventListener('click', function () { sheet.classList.remove('is-on'); });
      }
      var chosen = [];
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      chosen = first.options.slice();
      p.options.forEach(function (o, i) {
        var vals = o.values.map(function (x) { return x.toLowerCase(); });
        var isPolish = vals.length === 2 && vals.join('|').indexOf('silver') > -1 && vals.join('|').indexOf('gold') > -1;
        if (isPolish) { o.values.forEach(function (x) { if (x.toLowerCase().indexOf(polish) > -1) chosen[i] = x; }); }
      });
      var optBox = sheet.querySelector('.br-pick__opts'); optBox.innerHTML = '';
      function match() { return p.variants.filter(function (v) { return v.options.every(function (x, k) { return x === chosen[k]; }); })[0]; }
      function paint() {
        var v = match(); var add = sheet.querySelector('.br-pick__add');
        sheet.querySelector('.br-pick__price').textContent = v ? 'Rs. ' + (v.price / 100).toLocaleString('en-IN') : '';
        add.disabled = !v || !v.available; add.textContent = v && !v.available ? 'Sold out' : 'Add to cart';
        add.classList.remove('is-pressed');
        optBox.querySelectorAll('button[data-i]').forEach(function (b) { b.classList.toggle('is-on', chosen[Number(b.getAttribute('data-i'))] === b.getAttribute('data-value')); });
      }
      p.options.forEach(function (o, i) {
        if (o.values.length < 2) return;
        var g = d.createElement('div'); g.className = 'br-pick__g';
        var l = d.createElement('span'); l.className = 'br-pick__l'; l.textContent = o.name; g.appendChild(l);
        var row = d.createElement('div'); row.className = 'br-chips';
        o.values.forEach(function (val) {
          var b = d.createElement('button'); b.type = 'button'; b.className = 'br-chip'; b.textContent = val;
          b.setAttribute('data-i', i); b.setAttribute('data-value', val);
          b.addEventListener('click', function () { chosen[i] = val; paint(); });
          row.appendChild(b);
        });
        g.appendChild(row); optBox.appendChild(g);
      });
      sheet.querySelector('.br-pick__name').textContent = p.title;
      var add = sheet.querySelector('.br-pick__add');
      add.onclick = function () { var v = match(); if (v && v.available) addVariant(v.id, add).then(function () { setTimeout(function () { sheet.classList.remove('is-on'); }, 700); }); };
      paint();
      sheet.classList.add('is-on');
      if (btn) btn.classList.remove('is-pressed');
    }).catch(function () { window.location.href = '/products/' + handle; });
  }

  d.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.br-qa');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var polish = polishOf(btn);
    if (btn.getAttribute('data-simple') === '1') {
      var id = (polish === 'gold' ? btn.getAttribute('data-gold') : btn.getAttribute('data-silver')) || btn.getAttribute('data-first');
      if (id) { addVariant(id, btn); return; }
    }
    btn.classList.add('is-pressed');
    openPicker(btn.getAttribute('data-handle'), btn, polish);
  }, true);


  /* ---------------- 3. WISHLIST (saved in this browser) ----------------
     The Swym / Wishlist Hero apps are not running on the store, so the hearts keep their own list
     in localStorage and /pages/swym-wishlist shows it whenever the Swym container stays empty. */
  var WKEY = 'brWishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function wlPaint() {
    var a = wlGet();
    d.querySelectorAll('.br-wish[data-handle]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.br-wish[data-handle]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-handle'), a = wlGet(), i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); toast('Removed from wishlist'); } else { a.push(h); toast('Saved to wishlist'); }
    wlSet(a); wlPaint();
  }, true);
  function wlPage() {
    var box = d.getElementById('swym-wishlist-render-container');
    if (!box) return;
    setTimeout(function () {
      if (box.children.length || window._swat) return;
      var a = wlGet();
      box.classList.add('br-wl');
      if (!a.length) { box.innerHTML = '<p class="br-wl__empty">Your wishlist is empty. Tap the heart on any piece to save it here.</p>'; return; }
      box.innerHTML = '';
      a.forEach(function (h) {
        fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p) return;
          var el = d.createElement('div'); el.className = 'br-wl__item';
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          el.innerHTML = '<a href="/products/' + p.handle + '" class="br-media br-wl__img"><img alt="" loading="lazy"></a><div class="br-wl__name"></div><div class="br-wl__row"><span class="br-wl__price"></span><button type="button" class="br-wish is-on" data-handle="' + p.handle + '" aria-label="Remove from wishlist"></button></div>';
          if (img) el.querySelector('img').src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
          el.querySelector('.br-wl__name').textContent = p.title;
          el.querySelector('.br-wl__price').textContent = 'Rs. ' + (p.price / 100).toLocaleString('en-IN');
          box.appendChild(el); wlPaint();
        });
      });
    }, 2500);
  }

  /* phone product page: lift the floating app buttons above the buying sheet */
  function liftFloats() {
    if (!d.getElementById('br-pdp') || !window.matchMedia('(max-width: 767.98px)').matches) return;
    [['shopify-chat', '.activator-nudge{ transform:translateY(-236px) !important }'], ['gty-whatsapp-chat-button', '.gty-wacb-wrapper{ bottom:272px !important }']].forEach(function (cfg) {
      var tries = 0;
      (function attempt() {
        var host = d.querySelector(cfg[0]);
        if (host && host.shadowRoot) {
          if (!host.shadowRoot.getElementById('br-bw-lift')) { var s = d.createElement('style'); s.id = 'br-bw-lift'; s.textContent = cfg[1]; host.shadowRoot.appendChild(s); }
          return;
        }
        if (++tries < 40) setTimeout(attempt, 250);
      })();
    });
  }

  /* BR BW FIXES 2, 17 Sep 2026 */
  function brFix2() {
    var main = d.querySelector('.br-pdp__main'), first = d.querySelector('.br-pdp__slide img[width][height]');
    if (main && first) { var w = +first.getAttribute('width'), h = +first.getAttribute('height'); if (w && h) { main.style.setProperty('--br-ar', w + ' / ' + h); main.style.setProperty('--br-arn', (w / h).toFixed(4)); } }
    var sx = 0, sy = 0;
    d.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true, capture: true });
    function go(e, x, y) {
      var el = e.target.closest && e.target.closest('.br-stare-mark, .br-has-mark, .br-slide-link');
      if (!el) return;
      var a = el.closest('a') || el.parentNode.querySelector('a.br-slide-link') || (el.closest('.slideshow__slide') || d).querySelector('a.br-slide-link, a.cta_link');
      if (!a || !a.getAttribute('href')) return;
      if (x !== undefined && (Math.abs(x - sx) > 10 || Math.abs(y - sy) > 10)) return;
      e.preventDefault(); e.stopPropagation(); location.href = a.getAttribute('href');
    }
    d.addEventListener('touchend', function (e) { var t = e.changedTouches[0]; go(e, t.clientX, t.clientY); }, { capture: true });
    d.addEventListener('click', function (e) { go(e); }, true);
    /* currency pill: the app scales it and overrides stylesheet offsets, so line it up by measuring:
       centred on WhatsApp's centre line, 12px above the language button */
    var cn = 0;
    (function pinCur() {
      var c = d.querySelector('.buckscc-currency-wrapper'), l = d.querySelector('.eat-languageSelector');
      if (c && l && l.offsetWidth) {
        ['top', 'left', 'transform'].forEach(function (p) { c.style.setProperty(p, p === 'transform' ? 'none' : 'auto', 'important'); });
        var cs = getComputedStyle(c), lr = l.getBoundingClientRect(), cr = c.getBoundingClientRect();
        var right = parseFloat(cs.right) || 0, bottom = parseFloat(cs.bottom) || 0;
        var axis = lr.left + lr.width / 2;
        right += (cr.left + cr.width / 2) - axis;
        bottom += cr.bottom - (lr.top - 12);
        c.style.setProperty('right', right.toFixed(1) + 'px', 'important');
        c.style.setProperty('bottom', bottom.toFixed(1) + 'px', 'important');
      }
      if (++cn < 40) setTimeout(pinCur, 300);
    })();
    var cfgs = [['shopify-chat', '.activator-nudge{ transform:none !important; left:16px !important; right:auto !important; bottom:calc(var(--br-dock, 0px) + 20px) !important; }'],
      ['gty-whatsapp-chat-button', '.gty-wacb-wrapper{ transform:none !important; top:auto !important; left:auto !important; right:20px !important; bottom:calc(var(--br-dock, 0px) + 20px) !important; width:52px !important; height:52px !important; } .gty-wacb-button-container, .gty-wacb-button{ width:52px !important; height:52px !important; } .gty-wacb-button svg{ width:26px !important; height:26px !important; }']];
    cfgs.forEach(function (cfg) {
      var tries = 0;
      (function attempt() {
        var host = d.querySelector(cfg[0]);
        if (host && host.shadowRoot) {
          var s = host.shadowRoot.getElementById('br-bw-lift');
          if (!s) { s = d.createElement('style'); s.id = 'br-bw-lift'; host.shadowRoot.appendChild(s); }
          s.textContent = cfg[1];
          return;
        }
        if (++tries < 60) setTimeout(attempt, 250);
      })();
    });
  }

  /* BR INR NOTE, Sep 2026 (Vikas approved product, collection and cart notes, 17 Sep 2026): when a visitor views prices in another currency via the
     BUCKS converter, say plainly that the price is approximate and that checkout charges Indian rupees. */
  function brInrNote() {
    var fmt = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };
    function cur() {
      var m = d.querySelector('.money[bucks-currency]');
      if (m && /^[A-Z]{3}$/.test(m.getAttribute('bucks-currency'))) return m.getAttribute('bucks-currency');
      try { var a = JSON.parse(localStorage.getItem('buckscc_last_manual') || 'null'), b = JSON.parse(localStorage.getItem('buckscc_auto_currency') || 'null'); var x = (a && b) ? (a.timestamp > b.timestamp ? a : b) : (a || b); return (x && x.currency) || 'INR'; } catch (e) { return 'INR'; }
    }
    function put(anchor, id, html, after) {
      if (!anchor) return;
      var el = d.getElementById(id);
      if (!el) { el = d.createElement('p'); el.id = id; el.className = 'br-inr-note'; if (after) anchor.parentNode.insertBefore(el, anchor.nextSibling); else anchor.parentNode.insertBefore(el, anchor); }
      if (el.innerHTML !== html) el.innerHTML = html;
    }
    function drop(id) { var el = d.getElementById(id); if (el) el.remove(); }
    var cartInr = null, cartAt = 0;
    function tick() {
      var c = cur(), foreign = c !== 'INR';
      /* product page */
      var row = d.querySelector('.br-pdp__row2');
      if (row) {
        if (foreign) {
          var inr = null, sel = d.querySelector('form.product-form [name="id"]'), vj = d.getElementById('br-pdp-variants');
          try { var vs = JSON.parse(vj.textContent); var v = vs.filter(function (x) { return String(x.id) === String(sel && sel.value); })[0] || vs[0]; inr = v.price / 100; } catch (e) {}
          put(row, 'br-inr-pdp', 'Approx. price in ' + c + '. You pay <b>' + (inr ? fmt(inr) : 'in Indian rupees') + '</b> (Indian rupees) at checkout.', true);
        } else drop('br-inr-pdp');
      }
      /* collection and search pages */
      var bar = d.querySelector('.template-collection .collection-dropdowns, .template-search .search-results-header, .template-search .section-header');
      if (bar) { if (foreign) put(bar, 'br-inr-coll', 'Prices in ' + c + ' are approximate. You pay in Indian rupees (INR) at checkout.', true); else drop('br-inr-coll'); }
      /* cart page and cart drawer: above the checkout button */
      var btn = d.querySelector('.cart__checkout, .cart-drawer__checkout, form[action="/cart"] [name="checkout"]');
      if (btn) {
        if (foreign) {
          if (Date.now() - cartAt > 4000) { cartAt = Date.now(); fetch('/cart.js').then(function (r) { return r.json(); }).then(function (j) { cartInr = j.total_price / 100; }).catch(function () {}); }
          put(btn, 'br-inr-cart', 'At checkout you pay in Indian rupees: <b>' + (cartInr != null ? fmt(cartInr) : 'INR') + '</b> + shipping. Your bank converts it to ' + c + ', so your statement may differ slightly from the prices shown here.', false);
        } else drop('br-inr-cart');
      }
    }
    tick(); setInterval(tick, 800);
  }

  /* BR CART COUNT, Sep 2026: number of items on the bag icon (header and scroll-up bar).
     The theme's own bubble span is misspelt (site-header_cart-bubble) so nothing ever lit it up. */
  function brCartCount() {
    var busy = false, last = -1;
    function paint(n) {
      last = n;
      d.querySelectorAll('.site-header a[href="/cart"], .br-sticky__cart').forEach(function (a) {
        var b = a.querySelector('.br-cart-count');
        if (!b) { b = d.createElement('span'); b.className = 'br-cart-count'; b.setAttribute('aria-hidden', 'true'); a.appendChild(b); }
        b.textContent = n > 99 ? '99+' : String(n);
        b.classList.toggle('is-on', n > 0);
        a.setAttribute('aria-label', n > 0 ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart');
      });
    }
    function refresh() {
      if (busy) return; busy = true;
      (window.__brFetch || fetch)('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (j) { paint(j.item_count || 0); }).catch(function () {}).then(function () { busy = false; });
    }
    var isCart = function (u) { return /\/cart\/(add|change|update|clear)/.test(String(u || '')); };
    if (!window.__brFetch) {
      window.__brFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var p = window.__brFetch(input, init);
        var u = typeof input === 'string' ? input : (input && input.url);
        if (isCart(u)) p.then(function () { setTimeout(refresh, 150); }, function () {});
        return p;
      };
      var open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) {
        if (isCart(u)) this.addEventListener('loadend', function () { setTimeout(refresh, 150); });
        return open.apply(this, arguments);
      };
    }
    d.addEventListener('visibilitychange', function () { if (!d.hidden) refresh(); });
    window.addEventListener('pageshow', refresh);
    refresh();
  }

  /* BR SALE NOTE, 17 Sep 2026: weekend sale line on the cart page and in the cart drawer.
     The cart template has no discount line of its own, so the tier is worked out from the
     cart subtotal and matches the four automatic discounts in Shopify.
     Shows itself only between the sale start and end; after that nothing renders. */
  function brSaleNote() {
    var START = new Date('2026-09-17T18:31:00Z'), END = new Date('2026-09-21T06:59:59Z');
    var TIERS = [[70000, 20], [45000, 15], [20000, 10], [0, 5]];
    var ENDS = 'Monday 21 September, 12:30 pm';
    var fmt = function (n) { return '\u20B9' + Math.round(n).toLocaleString('en-IN'); };
    var busy = false, last = '';
    function tier(sub) { for (var i = 0; i < TIERS.length; i++) { if (sub >= TIERS[i][0]) return TIERS[i]; } return TIERS[TIERS.length - 1]; }
    function next(sub) { for (var i = TIERS.length - 1; i >= 0; i--) { if (TIERS[i][0] > sub) return TIERS[i]; } return null; }
    function drop() { var e = d.getElementById('br-sale'); if (e) e.remove(); }
    function render(sub) {
      var btn = d.querySelector('.cart__checkout, .cart-drawer__checkout, form[action="/cart"] [name="checkout"]');
      if (!btn || !sub) { drop(); return; }
      var t = tier(sub), n = next(sub);
      var html = '<p class="br-sale__k">Weekend sale</p>' +
        '<p class="br-sale__m"><b>' + t[1] + '% off</b> this order \u00B7 you save <b>' + fmt(sub * t[1] / 100) + '</b></p>' +
        (n ? '<p class="br-sale__n">Add ' + fmt(n[0] - sub) + ' more for ' + n[1] + '% off.</p>' : '') +
        '<ul class="br-sale__t"><li>Up to \u20B919,999 \u2014 5%</li><li>\u20B920,000 \u2013 \u20B944,999 \u2014 10%</li><li>\u20B945,000 \u2013 \u20B969,999 \u2014 15%</li><li>\u20B970,000 and above \u2014 20%</li></ul>' + '<p class="br-sale__s">Ends ' + ENDS + '.</p>';
      var el = d.getElementById('br-sale');
      if (!el) { el = d.createElement('div'); el.id = 'br-sale'; el.className = 'br-sale'; var anc = btn.closest('.btn-group') || btn; anc.parentNode.insertBefore(el, anc); }
      if (html !== last) { el.innerHTML = html; last = html; }
    }
    function tick() {
      var now = new Date();
      if (now < START || now > END) { drop(); return; }
      if (!d.querySelector('.cart__checkout, .cart-drawer__checkout, form[action="/cart"] [name="checkout"]')) return;
      if (busy) return; busy = true;
      (window.__brFetch || fetch)('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (j) { render((j.items_subtotal_price || j.total_price || 0) / 100); })
        .catch(function () {}).then(function () { busy = false; });
    }
    tick();
    setInterval(tick, 2500);
  }

  /* BR SALE POPUP, 18 Sep 2026: weekend sale banner shown once per visit, inside the sale window only. */
  function brSalePop() {
    var START = new Date('2026-09-17T18:31:00Z'), END = new Date('2026-09-21T06:59:59Z');
    var now = new Date();
    if (now < START || now > END) return;
    try { if (sessionStorage.getItem('brSalePop') === '1') return; } catch (e) {}
    if (/\/(cart|checkouts)/.test(location.pathname)) return;
    var w = d.createElement('div');
    w.id = 'br-pop';
    w.innerHTML =
      '<div class="br-pop__bg"></div>' +
      '<div class="br-pop__box br-pop__box--img" role="dialog" aria-label="Weekend sale">' +
        '<button class="br-pop__x" type="button" aria-label="Close">&times;</button>' +
        '<img class="br-pop__img" src="https://cdn.shopify.com/s/files/1/2675/8584/files/Sale_banner_E_luxe_compact_10bb5493-19b9-43af-a729-15e1989cc2b9.png?v=1789669496&width=1400" alt="Upto 20% off sale, online 18th to 20th September. Up to Rs 19,999 5% off, Rs 20,000 to Rs 44,999 10% off, Rs 45,000 to Rs 69,999 15% off, Rs 70,000 and above 20% off. Discount applied directly at checkout.">' +
        '<a class="br-pop__cta" href="/collections/shop-all">Shop Sale</a>' +
      '</div>';
    d.body.appendChild(w);
    try { sessionStorage.setItem('brSalePop', '1'); } catch (e) {}
    var close = function () { w.classList.add('is-off'); setTimeout(function () { w.remove(); }, 250); };
    w.querySelector('.br-pop__x').addEventListener('click', close);
    w.querySelector('.br-pop__bg').addEventListener('click', close);
    w.querySelector('.br-pop__cta').addEventListener('click', close);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    requestAnimationFrame(function () { w.classList.add('is-on'); });
  }

  /* BR GOOD TO KNOW, 18 Sep 2026: five tiles under the product accordions.
     The old theme tab row (pro-dr-tabs-info-out) is hidden in the black & white design; this
     brings back the five useful panels. The panel's ORIGINAL node is moved into the sheet so the
     COD pincode checker keeps working, and moved back when the sheet closes. */
  function brTrust() {
    if (!d.querySelector('.br-pdp__main')) return;
    if (d.querySelector('.br-trust')) return;
    var last = [].slice.call(d.querySelectorAll('.br-pdp__acc details, details')).pop();
    if (!last) return;
    var ICON = {
      cod: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="3"/></svg>',
      cert: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="9" r="5"/><path d="M8.5 13.5 7 22l5-2.5L17 22l-1.5-8.5"/></svg>',
      hand: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3c2.5 3 5 5 5 8a5 5 0 0 1-10 0c0-3 2.5-5 5-8z"/></svg>',
      gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="9" width="18" height="12" rx="1"/><path d="M3 13h18M12 9v12M12 9c-2 0-4-1-4-3s3-1 4 3c1-4 4-5 4-3s-2 3-4 3z"/></svg>',
      faq: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.4 2.3c-.6.3-.9.8-.9 1.4v.3"/><circle cx="12" cy="17" r=".6" fill="#fff" stroke="none"/></svg>'
    };
    var ITEMS = [
      ['Pay on delivery', ICON.cod, 'Pay on delivery', 'HTML:<p>Pay for your order when it reaches your door \u2014 available on orders <b>within India</b> only.<\/p><p>Cash on delivery is offered on orders between <b>\u20B96,000 and \u20B99,000<\/b>. Below or above that, orders are prepaid (UPI, cards, wallets, international cards).<\/p><p>International orders are prepaid only.<\/p>'],
      ['925 silver certificate', ICON.cert, 'Certificate of authenticity', '.cc-modal-window__content_cert-cls'],
      ['Handmade in Jaipur', ICON.hand, 'Handmade', '.cc-modal-window__content-handmade-cls'],
      ['Gift wrapping', ICON.gift, 'Gift wrap', '.cc-modal-window__content-gift_wrap-cls'],
      ['Questions', ICON.faq, 'Product FAQs', '.cc-modal-window__content-faqs-cls']
    ].filter(function (it) { return it[3].indexOf('HTML:') === 0 || d.querySelector(it[3]); });
    if (!ITEMS.length) return;
    var wrap = d.createElement('div');
    wrap.className = 'br-trust';
    wrap.innerHTML = '<p class="br-trust__k">Good to know</p><div class="br-trust__grid">' +
      ITEMS.map(function (it, i) { return '<button class="br-trust__t" type="button" data-i="' + i + '">' + it[1] + '<span>' + it[0] + '</span></button>'; }).join('') +
      '</div>';
    last.parentNode.insertBefore(wrap, last.nextSibling);
    var sh = d.createElement('div');
    sh.id = 'br-sheet';
    sh.innerHTML = '<div class="bg"></div><div class="box" role="dialog"><button class="x" type="button" aria-label="Close">&times;</button><h3></h3><div class="c"></div></div>';
    d.body.appendChild(sh);
    var home = null, node = null;
    function close() {
      sh.classList.remove('is-on');
      if (node && home) { home.appendChild(node); }
      node = null; home = null;
      d.documentElement.style.overflow = '';
    }
    sh.querySelector('.bg').addEventListener('click', close);
    sh.querySelector('.x').addEventListener('click', close);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    wrap.querySelectorAll('.br-trust__t').forEach(function (b) {
      b.addEventListener('click', function () {
        var it = ITEMS[+b.dataset.i];
        var c0 = sh.querySelector('.c');
        if (it[3].indexOf('HTML:') === 0) {
          if (node && home) home.appendChild(node);
          node = null; home = null;
          sh.querySelector('h3').textContent = it[2];
          c0.innerHTML = it[3].slice(5);
          sh.classList.add('is-on');
          d.documentElement.style.overflow = 'hidden';
          return;
        }
        var el = d.querySelector(it[3]);
        if (!el) return;
        if (node && home) home.appendChild(node);
        home = el.parentNode; node = el;
        sh.querySelector('h3').textContent = it[2];
        var c = sh.querySelector('.c');
        c.innerHTML = '';
        c.appendChild(el);
        sh.classList.add('is-on');
        d.documentElement.style.overflow = 'hidden';
      });
    });
  }

  function brUtil() {
    var u = d.querySelector('.br-util'); if (!u) return;
    var line = u.querySelector('.br-util__line'); if (!line) return;
    if (line.querySelector('.br-shop')) { u.classList.add('br-util--one'); return; }
    var bou = u.querySelector('.br-util__boutique');
    var href = (bou && bou.getAttribute('href')) || '/pages/retail-store';
    line.innerHTML = 'Handcrafted in Jaipur \u00b7 <a class="br-shop" href="' + href + '">Our stores <span aria-hidden="true">&#8594;</span></a> \u00b7 Ships worldwide';
    u.classList.add('br-util--one');
  }

  function brFly() {
    try { if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
    function cartEl() { return d.querySelector('.site-header a[href*="/cart"]') || d.querySelector('.site-header [class*="cart"]'); }
    function imgFor(btn) {
      var card = btn.closest ? btn.closest('.card, .grid-product, .br-best__item, .card-list__column') : null;
      var im = card ? card.querySelector('img') : null;
      if (!im) im = d.querySelector('.br-pdp__slide img, .br-pdp__main img, .product-single__photo img, .product__photo img');
      return im;
    }
    function fly(im) {
      var cart = cartEl(); if (!im || !cart) return;
      var s = im.getBoundingClientRect(), c = cart.getBoundingClientRect();
      if (!s.width || !c.width) return;
      var size = Math.min(s.width, s.height, 150); if (size < 44) size = 88;
      var x0 = s.left + s.width / 2, y0 = s.top + s.height / 2;
      var x1 = c.left + c.width / 2, y1 = c.top + c.height / 2;
      var g = d.createElement('img'); g.className = 'br-fly'; g.setAttribute('alt', '');
      g.src = im.currentSrc || im.src;
      g.style.width = size + 'px'; g.style.height = size + 'px';
      g.style.left = (x0 - size / 2) + 'px'; g.style.top = (y0 - size / 2) + 'px';
      d.body.appendChild(g);
      var t0 = null, DUR = 640, lift = Math.max(70, Math.min(170, (y0 - y1) * 0.34));
      function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / DUR);
        var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        var x = x0 + (x1 - x0) * e;
        var y = y0 + (y1 - y0) * e - Math.sin(Math.PI * e) * lift;
        var sc = 1 - 0.82 * e;
        g.style.transform = 'translate(' + (x - x0) + 'px,' + (y - y0) + 'px) scale(' + sc + ') rotate(' + (e * -16) + 'deg)';
        g.style.opacity = String(k < 0.86 ? 1 : (1 - (k - 0.86) / 0.14));
        if (k < 1) requestAnimationFrame(step);
        else {
          if (g.parentNode) g.parentNode.removeChild(g);
          var ci = cartEl();
          if (ci) { ci.classList.remove('br-cartpulse'); void ci.offsetWidth; ci.classList.add('br-cartpulse'); setTimeout(function () { ci.classList.remove('br-cartpulse'); }, 700); }
        }
      }
      requestAnimationFrame(step);
    }
    d.addEventListener('click', function (ev) {
      var t = ev.target; if (!t || !t.closest) return;
      var b = t.closest('button[name="add"], .br-qa, .btn--add-to-cart, .product-form__cart-submit, .add-to-cart, [data-br-add]');
      if (!b || b.disabled) return;
      var im = imgFor(b); if (im) fly(im);
    }, true);
  }

  function boot() { initPdp(); initCards(); wlPaint(); wlPage(); brFix2(); brInrNote(); brCartCount(); brSaleNote(); brSalePop(); brTrust(); brUtil(); brFly(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  window.BRBW = { initCards: initCards };
})();
